var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupDude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.999,
    height: 490.561,
    viewBox: "0 0 151.999 490.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_684",
    "data-name": "Gruppe 684",
    transform: "translate(-769.841 -140.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_190",
    "data-name": "Pfad 190",
    d: "M970.42,735.63c.226,23.706-149.154,25.878-152,0C818.194,711.928,967.574,709.755,970.42,735.63Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#23607a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_191",
    "data-name": "Pfad 191",
    d: "M623.966,507.569l-11.1,6.055,7.065,23.213,11.1,1.009,6.056-13.12Z",
    transform: "translate(181 23)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_192",
    "data-name": "Pfad 192",
    d: "M658.28,553.994v11.1l17.157-1.009-.239-9.143Z",
    transform: "translate(181 23)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_193",
    "data-name": "Pfad 193",
    d: "M619.929,374.348l6.055,75.694L645.16,561.058l30.277-4.037-10.092-87.8,4.037-80.739Z",
    transform: "translate(181 23)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_194",
    "data-name": "Pfad 194",
    d: "M930.248,463.6l-72.666,1.009-8.074,55.508,49.453,23.213,12.111,44.407-61.563,65.6,24.222,30.277s34.314-46.425,59.545-72.666S946.4,504.977,946.4,504.977Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 22.203,
    cy: 22.203,
    r: 22.203,
    transform: "translate(816.068 153.112)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_195",
    "data-name": "Pfad 195",
    d: "M878.777,313.221v22.2l15.139,24.222s23.213-17.157,18.166-21.194-6.055-35.324-6.055-35.324Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_196",
    "data-name": "Pfad 196",
    d: "M649.2,185.62l-15.139,18.166,6.056,126.155,47.434-1.009,8.074-110.007L685.53,190.666l-6.923-9.419-12.253,18.5Z",
    transform: "translate(181 23)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_197",
    "data-name": "Pfad 197",
    d: "M854.555,396.988l-11.1,42.388,11.1,42.388-18.166,24.222-16.148-76.7s12.111-62.573,13.12-69.638,3.028-8.074,3.028-8.074l8.074,1.009Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_198",
    "data-name": "Pfad 198",
    d: "M705.714,267.368l7.065,13.121,2.019,22.2-4.037,25.231,14.129,23.213,14.129-63.583L723.881,205.8h-6.056Z",
    transform: "translate(181 23)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_199",
    "data-name": "Pfad 199",
    d: "M849.509,652.327s-14.129,4.037-19.176,5.046,3.028,20.185,3.028,20.185,5.046,26.24,6.055,31.287,8.074,22.2,17.157,24.222,3.028-35.324,3.028-35.324,4.037-12.111,4.037-16.148-6.055-2.018-6.055-2.018C841.435,677.558,849.509,652.327,849.509,652.327Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_200",
    "data-name": "Pfad 200",
    d: "M882.814,730.039c1.009,6.055-1.009,6.055,15.139,8.074s12.111-11.1,12.111-11.1a84.809,84.809,0,0,0-4.037-18.166c-3.028-8.074-19.176,2.018-19.176,2.018S881.8,723.983,882.814,730.039Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_201",
    "data-name": "Pfad 201",
    d: "M906.053,303.833l.526,8.976s6.512-14.727,7.522-29.865-16.149-18.166-26.241-19.175-27.25,6.055-27.25,14.129,18.166,6.055,25.231,4.037,10.092,15.139,10.092,15.139l4.037,1.009Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_202",
    "data-name": "Pfad 202",
    d: "M643.24,192.767l5.957-7.147,17.157,14.129L649.2,211.86Z",
    transform: "translate(181 23)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_203",
    "data-name": "Pfad 203",
    d: "M685.53,190.666l-7.065-9.083-12.111,18.166,15.139,11.1Z",
    transform: "translate(181 23)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_204",
    "data-name": "Pfad 204",
    d: "M851.527,411.117l4.037,38.351-8.074,23.213-5.046,22.2s0,21.194,20.185,22.2,37.342-63.582,37.342-63.582,3.028,14.129,5.046,22.2,36.333,40.37,36.333,40.37,8.074-1.009,15.139-17.157-14.129-31.287-14.129-31.287L936.3,446.441l2.018-26.24,14.13-68.629-41.884-21.7L915.11,387.9l-15.139,45.416L877.263,332.9l-7.569,5.551-32.3,13.121Z",
    transform: "translate(-48.58 -122.767)",
    fill: "#00273c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupDude);
export default __webpack_public_path__ + "static/media/signup-dude.727109b5.svg";
export { ForwardRef as ReactComponent };